import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { CollaboratoreDTO } from '../domain/collaboratore';
import { ServizioDTO } from './servizio';

export class PreferitiDTO extends LogicalDeleteDTO {
    id: number;
    collaboratore: CollaboratoreDTO;
    servizio: ServizioDTO;
}